<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconColumns_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M1.5 17.77V6.087q0-.964.686-1.65a2.25 2.25 0 0 1 1.65-.687h16.327a2.25 2.25 0 0 1 1.65.686 2.25 2.25 0 0 1 .687 1.65V17.77a2.25 2.25 0 0 1-.686 1.65 2.25 2.25 0 0 1-1.65.686H3.836a2.25 2.25 0 0 1-1.65-.686 2.25 2.25 0 0 1-.687-1.65m2.307 0h3.885V6.087H3.807zm6.221 0h3.885V6.087h-3.885zm6.222 0h3.884V6.087H16.25z"
    />
</svg>
